import React from 'react';
import * as apiActions from 'aster-foundation/core/epharmacy/Product/redux/action';
import { PropTypes } from 'prop-types';
import Image from 'next/image';
import { IC_PERCENTAGE_OFFER_GREEN } from '@common/Assets/images';
import { useDispatch, useSelector } from 'react-redux';
import { errorHandlingEpharmacy, getImageUrlWithSize } from '@common/Utility/common-utils';
import CustomModal from '@common/Component/Modal/Modal';
import ReturnableRibbon from './ReturnableRibbon';
import { isRTL, useTranslation } from '@common/i18n';
import { getLangCodeFromUrl } from '../../../../i18n';

const showLimit = 1;

const ProductOffers = ({ sku, isPOMEnabled, detailsData, customAttribute }) => {
  const dispatch = useDispatch();
  const t = useTranslation();
  const userLogin = useSelector((state) => state?.astercore?.checkUserExist?.data?.entry[0]?.resource);
  const guestLogin = useSelector((state) => state?.astercore?.guestAccessToken?.data);
  const [showAll, setShowAll] = React.useState(false);
  const [infoModalData, setInfoModalData] = React.useState({ visible: false });
  const [offersList, setOffersList] = React.useState([]);
  const [offers, setOffers] = React.useState([]);
  const [offerBanner, setOfferBanner] = React.useState({});
  const [currentLang, setCurrentLanguage] = React.useState('');
  const fetchRichContent = () => {
    if (guestLogin  || userLogin) {
      dispatch(
        apiActions.getProductPromotionRules({
          params: { sku: sku },
          onSuccess: (res) => {
            const content = res?.data?.content;
            const banner = content?.find((item) => item?.contentType === 'img');
            setOfferBanner(banner);
            setOffersList(content?.filter((item) => item?.contentType === 'txt'));
          },
          onError: (e) => {
            errorHandlingEpharmacy(e, true);
          },
        }),
      );
    }
  };
  React.useEffect(() => {
    if(window !== 'undefined'){
      setCurrentLanguage(getLangCodeFromUrl());
    }
  }, []);
  React.useEffect(() => {
    if (sku) {
      fetchRichContent();
    }
  }, [sku, userLogin, guestLogin]);
  React.useEffect(() => {
    if (!showAll && offersList?.length > showLimit) {
      setOffers(offersList?.slice(0, showLimit));
    } else {
      setOffers(offersList);
    }
  }, [showAll, offersList]);

  return (
    <>
      {offers?.length > 0 && !isPOMEnabled && (
        <div className="bankOffersBox">
          {offers?.map((offerItem) => {
            return (
              <div className={`offersBox ${offersList?.length <= 1 ? 'border-0 pb-0' : ''}`}>
                <div className="ic">
                  <Image src={IC_PERCENTAGE_OFFER_GREEN.src} width="50px" height="50px" alt="offer" />
                </div>
                <div className="description">
                  <div className="text">
                    <strong>{offerItem?.contentTitle}:</strong>
                    {offerItem?.contentText}
                  </div>
                  {offerItem?.contentDescription && (
                    <div className="showHide" onClick={() => setInfoModalData({ visible: true, data: offerItem })}>
                      {t('ProductDetail.knowMore')}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
          {offersList?.length > 1 && (
            <div
              className="moreOffers"
              onClick={() => {
                setShowAll(!showAll);
              }}
            >
              {!showAll
                ? ( offersList?.length === 2
                    ? t('ProductDetail.viewXMoreOffer', {count: offersList?.length - 1})
                    : t('ProductDetail.viewXMoreOffers', {count: offersList?.length - 1})
                  )
                : t('ProductDetail.viewLess')}
            </div>
          )}
        </div>
      )}
      <ReturnableRibbon detailsData={detailsData} customAttribute={customAttribute} />
      {offerBanner?.contentImage && !isPOMEnabled && (
        <div className="pdpAdvtBox" onClick={() => setInfoModalData({ visible: true, data: offerBanner })} data-testid='pdpAdvtBox'>
          <Image src={getImageUrlWithSize(offerBanner?.contentImage, 544, 160)} width="544px" height="160px" alt="Special Offer Banner for Product Page" unoptimized/>
        </div>
      )}
      {infoModalData?.visible && infoModalData?.data && (
        <CustomModal
          titleLeftAligned={currentLang && !isRTL(currentLang) }
          titleRightAligned={currentLang && isRTL(currentLang) }
          footerBtnFullWidth={true}
          modalTitle={infoModalData?.data?.contentTitle}
          noFooter
          customClass="modal_pdpAdvtBox"
          contentMaxHeight="350px"
          size="lg"
          closeButton
          crossPressed={() => {
            setInfoModalData({ visible: false, data: null });
          }}
        >
          {infoModalData?.data?.contentDescription}
          {infoModalData?.data?.contentUrl && infoModalData?.data?.contentUrl !== '' && (
            <div>
              <a target="_blank" rel="noreferrer" href={infoModalData?.data?.contentUrl}>
                {t('ProductDetail.readmore')}
              </a>
            </div>
          )}
        </CustomModal>
      )}
    </>
  );
};

ProductOffers.propTypes = {
  sku: PropTypes.any,
  detailsData: PropTypes.any,
  customAttribute: PropTypes.any,
};

export default ProductOffers;
